import styled from 'styled-components';
import { string } from 'prop-types';
import { Text } from '@perch-labs/shrike';
import { breakpointStyles, getPropTypes } from './utils';

export const textStyles = props => ({
  textAlign: props.textAlign,
});

export const StyledText = styled(Text)<StyleProps>`
  ${textStyles}
  ${breakpointStyles(textStyles)}
`;

export const textProps = {
  textAlign: string,
};

StyledText.propTypes = getPropTypes(textProps);
